<template>
  <div class="progressWrap">
      <div class="content" v-if="timeInfo">
        <img src="../../../static/assets/img/progress/successIcon.png" />
        <p>开户申请提交{{ apptStatus <= 4 ? "预审" : "终审" }}成功！</p>
        <div class="progressCon">
          <Steps :current="index" size="small" direction="vertical">
            <Step title="提交预审申请"></Step>
            <Step title="预审通过"></Step>
            <Step title="双录见证，提交审核"></Step>
            <Step title="待业务审核"></Step>
            <Step title="等待开户结果"></Step>
          </Steps>
          <div class="progressData">
            <div class="updateDate" v-for="(k) in timeInfoObj" :key="k">{{timeInfo[k] }}</div>
            <!-- <div class="updateDate">{{ timeInfo.PRETRIALRESULTDATE }}</div>
            <div class="updateDate">{{ timeInfo.VIDEOREVIEWDATE }}</div>
            <div class="updateDate">{{ timeInfo.FINALREVIEWDATE }}</div>
            <div class="updateDate">{{ timeInfo.FINALRESULTDATE }}</div> -->
          </div>
        </div>
    </div>
    <!-- <div class="fixed_btn">
      <el-button @click="goPrev" class="button light-button prev" id="formPrintPrevBtn" v-show="isShowPrev&&apptStatus>=4">上一步</el-button>
      <el-button @click="skipToNext" class="button save next" id="formPrintPrevBtn" v-show="isShowNext&&apptStatus>=4">下一步</el-button>
    </div> -->
  </div>
</template>
<script>
import oppService from "@/service/opp-service";

export default {
  data () {
    return {
      index: 0,
      review: 0, //0是预审，1是终审
      timeInfo: {},
      timeInfoObj:{
        0: "PRETRIALREVIEWDATE",
        1: "PRETRIALRESULTDATE",
        2: "VIDEOREVIEWDATE",
        3: "FINALREVIEWDATE",
        4: "FINALRESULTDATE"
      }
    };
  },
  props:["isShowPrev", "isShowNext", "status"],
  computed: {
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    bSno () {
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    apptSn () {
      return this.$store.state.apptSn;
    },
  },
  created () {
  },
  mounted () {
    if(this.apptStatus < 4){
      this.index = 0;
    }else{
      this.index = 4;  
    }
    return this.getDataEx();
  },
  methods: {
    getDataEx () {
      this.$syscfg.K_Request("F0000068", {
        APPT_SN: this.apptSn 
      }).then(res => {
        this.timeInfo = res.Data && res.Data[0] || {};
        // for(let i in this.timeInfoObj){
        //   let k =  this.timeInfoObj[i];
        //   let item = this.timeInfo[k];
        //   if(!!item){
        //     this.index = parseInt(i);
        //   }
        // }
      
      });
    },
    // async  goPrev (){
    //   this.$router.goPrev();
    // },
    // async skipToNext () {
    //   this.$router.goNext();
    // },
  }
};
</script>
<style lang="less" scoped>
.progressWrap {
  width: 100%;
  height: 100%;
  position: relative;
  background: #ffffff;
  display: flex;
  justify-content: center;
  padding-top: 0.2rem;
  .collectContent{
    padding: 20px;
    background: #ffffff;
    border-radius: 5px;
    margin-top: 2px;
  }
  .content {
    text-align: center;
    p {
      font-size: 0.18rem;
      margin: 0.42rem 0;
    }
    .progressCon {
      display: flex;
      width: 7.23rem;
      background: #f6f7f9;
      border-radius: 5px;
      padding: 0.45rem 1rem 0;
      text-align: left;
    }
    .progressData {
      width: 3.8rem;
    }
    .updateDate {
      color: #333333;
      font-size: 0.16rem;
      min-height: 0.47rem;
    }
    /deep/.ivu-steps-item.ivu-steps-status-process .ivu-steps-head-inner {
      background: #d0aa72;
      border-color: #d0aa72;
    }
    .ivu-steps.ivu-steps-small .ivu-steps-title {
      color: #gray;
    }
    /deep/.ivu-steps.ivu-steps-small .ivu-steps-status-process .ivu-steps-title {
      margin-bottom: 4px;
      margin-top: 1px;
      color: #333333;
      font-size: 14px;
      font-weight: 700
    }
    /deep/.ivu-steps-vertical.ivu-steps-small .ivu-steps-title {
      margin-bottom: 4px;
      margin-top: 1px;
      font-size: 14px;
    }
    /deep/.ivu-steps-status-wait .ivu-steps-title {
      color: gray;
    }
    /deep/.ivu-steps-status-process .ivu-steps-title {
      color: #333333;
    }
    /deep/.ivu-steps-status-finish .ivu-steps-title {
      color: #333333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/progress/progress.vue